import { Injectable } from '@angular/core';

@Injectable()
export class SharedSettings {
    isProduction: boolean;
    buildNumber: string;

    appInsightsKey: string;

    authAuthority: string;
    authClientId: string;
    authScopes: string[];

    apiBaseUrl: string;
    hubsBaseUrl: string;
    oidenBaseUrl: string;

    validAccountDomains: string[];

    features: { [key: string]: boolean };

    fallbackTimeZone: string;
}
